<ion-content>
  <app-global-page-header [title]="title">
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="dismissModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>

  <div class="horizontal-menu-container px-3">
    <div class="row">
      <div class="col-auto">
        <ion-segment
          class="horizontal-menu"
          [value]="currentOnglet"
          (ionChange)="onCurrentOngletChange($event)"
        >
          @if (checkControle()) {
            <ion-segment-button value="control">
              <ion-label>{{ 'functions.menu.controle' | translate }}</ion-label>
            </ion-segment-button>
          }

          @if (checkParameter()) {
            <ion-segment-button value="settings">
              <ion-label>{{
                'functions.menu.parameters' | translate
              }}</ion-label>
            </ion-segment-button>
          }

          @if (checkStatus()) {
            <ion-segment-button value="status">
              <ion-label>{{ 'functions.menu.statuts' | translate }}</ion-label>
            </ion-segment-button>
          }
        </ion-segment>
      </div>
      <div class="col"></div>
    </div>
  </div>

  @if (this.currentOnglet === 'control' && cpsConfig!.controle.component) {
    <div class="p-3">
      <ng-container
        [ngComponentOutletInputs]="{
          productClass: this.productClass,
        }"
        [ngComponentOutlet]="cpsConfig!.controle.component"
      >
      </ng-container>
    </div>
  } @else if (
    this.currentOnglet === 'settings' &&
    cpsConfig!.parametrages.reglage.component
  ) {
    <div class="p-3">
      <ng-container
        [ngComponentOutletInputs]="{
          productClass: this.productClass,
        }"
        [ngComponentOutlet]="cpsConfig!.parametrages.reglage.component"
      >
      </ng-container>
    </div>
  } @else if (this.currentOnglet === 'status' && cpsConfig!.status.component) {
    <div class="p-3">
      <ng-container
        [ngComponentOutletInputs]="{
          productClass: this.productClass,
        }"
        [ngComponentOutlet]="cpsConfig!.status.component"
      >
      </ng-container>
    </div>
  }
</ion-content>
